function createFallbackUuid () {
  return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

export function createRequestId () {
  const crypto = typeof globalThis !== 'undefined' ? globalThis.crypto : null
  if (crypto && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID().replace(/-/g, '').toLowerCase()
  }
  return createFallbackUuid()
}

export function buildRequestIdHeader (headers = {}) {
  // vue-resource 的 request.headers 是 Headers 实例（带有 has/set/get 等方法），
  // 不能用对象展开复制，否则会丢失原型方法导致 `headers.has is not a function`。
  // 这里判断是否为 Headers 实例：是则原地修改并返回实例，否则按普通对象处理。
  if (headers && typeof headers.has === 'function' && typeof headers.set === 'function') {
    if (!headers.has('X-Request-Id')) {
      headers.set('X-Request-Id', createRequestId())
    }
    return headers
  }

  const nextHeaders = { ...headers }
  const hasRequestId = Object.keys(nextHeaders).some(key => key.toLowerCase() === 'x-request-id')
  if (!hasRequestId) {
    nextHeaders['X-Request-Id'] = createRequestId()
  }
  return nextHeaders
}
